export class ScheduleValidation {
    conflicts: number;
    empty_shifts: number;
}
